import React, { createContext, useState, useContext, ReactNode } from "react";

interface ScrollUnlockContextType {
	isScrollEnabled: boolean;
	unlockScroll: () => void;
}

const SunScrollContext = createContext<ScrollUnlockContextType | undefined>(undefined);

export const SunScrollProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const [isScrollEnabled, setIsScrollEnabled] = useState<boolean>(false);

	const unlockScroll = () => {
		setTimeout(() => {
			setIsScrollEnabled(true);
		}, 500);
	};

	return <SunScrollContext.Provider value={{ isScrollEnabled, unlockScroll }}>{children}</SunScrollContext.Provider>;
};

export const useSunScrollUnlock = (): ScrollUnlockContextType => {
	const context = useContext(SunScrollContext);
	if (!context) {
		throw new Error("useScrollUnlock must be used within a ScrollUnlockProvider");
	}
	return context;
};
